import React from 'react';
import { ClipboardList } from 'lucide-react';

/** Planning doc card — workflow uses compact brief chrome; pipeline uses icon strip. */
export function PlanningDocumentCard({
  title = 'April content brief',
  meta,
  accentColor = '#6366f1',
  className = '',
  variant = 'pipeline',
}) {
  const isWorkflowVariant = variant === 'workflow';

  return (
    <div
      className={`mkt-planning-doc-card${isWorkflowVariant ? ' mkt-planning-doc-card--workflow' : ''}${className ? ` ${className}` : ''}`}
      style={isWorkflowVariant ? { borderLeftColor: accentColor } : undefined}
    >
      <div className="mkt-planning-doc-card-badges">
        <span className="mkt-planning-doc-card-badge">
          {isWorkflowVariant ? (
            <ClipboardList className="mkt-planning-doc-card-badge-icon" aria-hidden />
          ) : null}
          Planning
        </span>
      </div>
      <div className="mkt-planning-doc-card-thumb-wrap">
        <div className="mkt-planning-doc-card-icon-strip">
          <div className="mkt-planning-doc-card-icon-strip-inner">
            <ClipboardList className="mkt-planning-doc-card-icon" aria-hidden />
          </div>
        </div>
      </div>
      <div className="mkt-planning-doc-card-body">
        <p className="mkt-planning-doc-card-title">{title}</p>
        {meta ? <p className="mkt-planning-doc-card-meta">{meta}</p> : null}
      </div>
    </div>
  );
}
